import api from './api';

export const createShiftSwap = (data) => api.post('/v1/shift-swaps', data);
export const getMyShiftSwaps = () => api.get('/v1/shift-swaps/my');
export const peerAcceptSwap = (id, data) => api.put(`/v1/shift-swaps/${id}/peer-accept`, data);
export const peerRejectSwap = (id, data) => api.put(`/v1/shift-swaps/${id}/peer-reject`, data);
export const cancelSwap = (id) => api.put(`/v1/shift-swaps/${id}/cancel`);
export const getPendingShiftSwaps = () => api.get('/v1/shift-swaps/pending');
export const approveSwap = (id, data) => api.put(`/v1/shift-swaps/${id}/approve`, data);
export const rejectSwap = (id, data) => api.put(`/v1/shift-swaps/${id}/reject`, data);
export const getTargetShifts = (params) => api.get('/v1/shift-swaps/target-shifts', { params });
